import type * as React from 'react';

export const assignRefs =
    <T>(...refs: (ReactRef<T> | undefined)[]) =>
    (current: T | null) => {
        refs.forEach((ref) => {
            if (typeof ref === 'function') {
                ref(current);
            } else if (ref) {
                ref.current = current;
            }
        });
    };

export type ReactRef<T> = React.RefCallback<T | null> | React.MutableRefObject<T | null> | null;

export interface DataAttributes {
    [dataAttribute: `data-${string}`]: $TSFixMe;
}
